"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Confirmation = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
require("./confirmation.css");
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const heading_1 = require("@nbc-design/heading");
const AttentionOutlineThin_1 = require("@nbc-design/icons/lib/web/AttentionOutlineThin");
const FailureOutlineThin_1 = require("@nbc-design/icons/lib/web/FailureOutlineThin");
const Info_1 = require("@nbc-design/icons/lib/web/Info");
const PendingOutlineThin_1 = require("@nbc-design/icons/lib/web/PendingOutlineThin");
const SuccessOutlineThin_1 = require("@nbc-design/icons/lib/web/SuccessOutlineThin");
const WaitingOutlineThin_1 = require("@nbc-design/icons/lib/web/WaitingOutlineThin");
/** Confirmations are used at the end of a process to display the outcome. It can be a success, a failure or a warning. */
const Confirmation = ({ children, id, title, className, appearance = 'success', type = 'h2', dataTest = 'confirmation', size = 'normal', ...other }) => {
    const pictoSize = { width: 64, height: 64 };
    const pictoConfigByAppearance = {
        error: FailureOutlineThin_1.FailureOutlineThin,
        success: SuccessOutlineThin_1.SuccessOutlineThin,
        warning: AttentionOutlineThin_1.AttentionOutlineThin,
        waiting: WaitingOutlineThin_1.WaitingOutlineThin,
        pending: PendingOutlineThin_1.PendingOutlineThin,
    };
    const SelectedPicto = pictoConfigByAppearance[appearance] || Info_1.Info;
    const pictoClass = (0, classnames_1.default)('dsc-confirmation__picto', `dsc-confirmation__picto--${appearance}`);
    const Picto = (0, jsx_runtime_1.jsx)(SelectedPicto, { size: pictoSize, className: pictoClass });
    const classes = (0, classnames_1.default)('dsc-confirmation', appearance ? `dsc-confirmation--${appearance}` : null, size !== 'normal' && `is-${size}`, className);
    return ((0, jsx_runtime_1.jsxs)("div", { ...other, id: id, className: classes, "data-test": dataTest, role: "alert", "aria-live": "assertive", children: [(0, jsx_runtime_1.jsxs)("div", { className: "dsc-confirmation__titleContainer", children: [Picto, (0, jsx_runtime_1.jsx)(heading_1.Heading, { size: size === 'small' ? 5 : 4, type: type, className: "dsc-confirmation__title", children: title })] }), children] }));
};
exports.Confirmation = Confirmation;
exports.Confirmation.displayName = 'Confirmation';
//# sourceMappingURL=confirmation.js.map